<script>

import AtaService from "services/manter-ata.service"
import AprovarAtaDialog
  from "views/post-login/administrador/manter-ata/dialogs/AprovarAtaDialog.vue";
import { Dialog } from "commons/classes/dialog";

export default {
  name: "AprovarAtaView",
  mixins: [AtaService],
  components: {AprovarAtaDialog},
  data: () => ({
    dialogAprovarAta: Dialog.Build(),
    form: {
      filters: {
        formacao: null,
        dataRealizacao: null,
        situacao: null,
      },
      lists: {
        situacoes: ["Aguardando Aprovação - Ata", "Concluída"],
      }
    },
    list: {
      itens: [],
      headers: [
        { text: 'Formação', align: 'center', value: 'nome', cellClass: 'text-wrap' },
        { text: 'Solicitante', align: 'center', value: 'solicitante', cellClass: 'text-wrap' },
        { text: 'Data de Realização', align: 'center', value: 'dataRealizacao', cellClass: 'text-wrap' },
        { text: 'Situação', align: 'center', value: 'situacao', cellClass: 'text-wrap' },
        { text: 'Ações', align: 'center', value: 'acoes', sortable: false },
      ]
    }
  }),
  methods: {
    async buscarAtasParaAprovacao() {
      const {data} = await this.$buscarAtasParaAprovacao({params: {...this.form.filters}})
      this.list.itens = data.lista;
    },
    resetForm() {
      this.form.filters = {
        formacao: null,
        dataRealizacao: null,
        situacao: null,
      }
      this.list.itens = [];
    },
    async detalharAtaParaAvaliacao(ata) {
      const { data } = await this.$detalharAta(ata.id)
      this.dialogAprovarAta.open(data.item, true)
    },
    async baixarAta(ata) {
      const { data } = await this.$baixarAta(ata.id, { responseType: "blob" });
      const url = URL.createObjectURL(data);
      const a = document.createElement("a");
      a.href = url;
      a.download = "atas.zip";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    },
    async onCloseDialog() {
      this.dialogAprovarAta.close()
      await this.buscarAtasParaAprovacao()
    },
  },
}
</script>

<template>
  <div class="page">
    <v-container>
      <v-form ref="form" @submit.prevent="buscarAtasParaAprovacao">
        <v-row class="d-flex justify-center mt-3">
          <v-col cols="3">
            <v-text-field
                label="Formação"
                v-model="form.filters.formacao"
                outlined
                dense
            ></v-text-field>
          </v-col>
          <sigfoco-date-picker
              :cols="3"
              label="Data de Realização"
              v-model="form.filters.dataRealizacao"
              removeIcon
              outlined
              dense
          ></sigfoco-date-picker>
          <v-col cols="3">
            <v-select
                label="Status"
                :items="form.lists.situacoes"
                v-model="form.filters.situacao"
                outlined
                dense
            ></v-select>
          </v-col>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-submit-button />
            <sigfoco-tooltip
                :text="'Limpar'"
                :icon="'mdi-eraser'"
                @click="resetForm()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
          class="mt-5"
          :headers="list.headers"
          :items="list.itens"
          :items-per-page="10"
          :footer-props="$footerProps"
      >
        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
              v-if="item.situacao !== 'Concluída'"
              text="Aprovar Ata"
              icon="mdi-calendar-check"
              small
              @click="detalharAtaParaAvaliacao(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
              v-if="item.situacao === 'Concluída'"
              text="Baixar Ata"
              icon="mdi-download"
              small
              @click="baixarAta(item)"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <AprovarAtaDialog
        :visible="dialogAprovarAta.visible"
        :content="dialogAprovarAta.content"
        :edit="dialogAprovarAta.edit"
        @onClose="onCloseDialog"
    ></AprovarAtaDialog>
  </div>
</template>

<style scoped>

</style>